/**
 * Extra yang berasal dari POS.
 *
 * Baris ini dibuat lewat integrasi partner POS dan DIKUNCI di API
 * (BookingExtraController menolak update/destroy bila source = 'pos').
 * UI harus mencerminkan itu, supaya user tidak menekan tombol yang
 * pasti gagal dengan error 422.
 */
export const POS_SOURCE = 'pos';

/** Penanda extra POS yang sudah dibatalkan dari sisi POS. */
export const CANCELLED_PREFIX = '[BATAL]';

export const isPosExtra = (source?: string | null): boolean => source === POS_SOURCE;

export const isCancelledExtra = (itemName?: string | null): boolean =>
    Boolean(itemName?.startsWith(CANCELLED_PREFIX));

export const POS_LOCK_MESSAGE =
    'This extra comes from POS and cannot be modified from PMS. Cancel it through the POS app.';
